import { MetaZoneValues, TimeZoneStableIds } from './autogen.timezones';
import { KeyIndexImpl } from '../instructions';
/**
 * @public
 */
export var MetaZoneIndex = new KeyIndexImpl(MetaZoneValues);
/**
 * @public
 */
export var TimeZoneTypeIndex = new KeyIndexImpl(['daylight', 'generic', 'standard']);
/**
 * @public
 */
export var TimeZoneStableIdIndex = new KeyIndexImpl(TimeZoneStableIds);
//# sourceMappingURL=timezones.js.map